var map = {
	"./R1Q1.vue": 7483,
	"./R1Q4.vue": 4752,
	"./R2Q1.vue": 5731,
	"./R2Q3.vue": 4900,
	"./R2Q4.vue": 9008,
	"./R2Urgent.vue": 721,
	"./R3Q1.vue": 1597,
	"./R3Q2.vue": 1008,
	"./R3Q3.vue": 265,
	"./R4DrawerQuestion.vue": 582,
	"./R4PlateQuestion.vue": 2366,
	"./R4Q1.vue": 8050,
	"./R4Q3.vue": 4203,
	"./common/Instructions.vue": 7832,
	"./common/Task.vue": 7008,
	"./common/TaskDescription.vue": 8538,
	"./question-components/ChocolateBarDraggable.vue": 9711,
	"./question-components/DragAndDrop.vue": 7167,
	"./question-components/GradualFill.vue": 8330,
	"./question-components/ImageModal.vue": 6878,
	"./question-components/OptionTag.vue": 6661,
	"./question-components/PostItNoteDropzone.vue": 9297,
	"./question-components/ResourceSpender.vue": 1633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2313;